export default __webpack_public_path__ + "static/media/template.74d9896c.svg";